import React, { useState } from 'react'
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { LuListMusic } from "react-icons/lu";

function Dashboard() {

  const [data,setdata] = useState({users:0,songs:0})  
  return (
    <div>
       
        <h1 className='my-2 mt-4 font-[800] text-[13px]'>My Dashboard</h1>

        <div className='grid md:grid-cols-5'>
        <div className='border mr-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]'>
            <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><MdOutlineSpaceDashboard size={23} className='mr-2 bg-slate-200 p-1 text-slate-500' /> Users  </h6>
            <h6 className='text-[14px] mt-1'>{data?.users}</h6>
        </div>

        <div className='border mr-2 mt-2 md:mb-0 border-slate-200 px-2 py-2 w-[96%]'>
            <h6 className='text-[12px] text-slate-700 font-[600] flex items-center'><LuListMusic size={23} className='mr-2 bg-slate-200 p-1 text-slate-500' /> Songs </h6>
            <h6 className='text-[14px] mt-1'>{data?.songs}</h6>
        </div>
        </div>
    </div>
  )
}

export default Dashboard